import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SessionService } from 'src/app/service/session.service';

@Component({
  selector: 'flow-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss']
})
export class SignInComponent {

  public signInForm: FormGroup;
  public resetForm: FormGroup;

  public passwordControlType: string = 'password';
  
  public showReset = false;

  public disableSignInBtn = false;
  public disableResetBtn = false;

  public signInError = false;
  public resetError = false;

  public resetSuccess = false;

  constructor(
    private fb: FormBuilder,
    private session : SessionService,
  ) {

    this.signInForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
    }, { });
    
    this.resetForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    }, { });

  }

  public onSubmitSignIn() {
    if (this.signInForm.valid) {
      this.passwordControlType = 'password';

      this.disableSignInBtn = true;

      this.session.signIn(this.signInForm.value)
        .subscribe({
          next: (response) => {
            this.disableSignInBtn = false;
          },
          error: (error) => {
            this.signInError = true;
            setTimeout(() => {
              this.disableSignInBtn = false;
              this.signInError = false;
            }, 1000);
          }
        });
    }
  }

  public onSubmitReset() {
    if (this.resetForm.valid) {
      
      this.resetSuccess = false;
      this.disableResetBtn = true;

      this.session
        .resetPassword(this.resetForm.value)
        .subscribe({
          next: (response) => {
            this.resetSuccess = true;
            this.disableResetBtn = false;
            this.resetForm.reset();

            setTimeout(() => {
              this.resetSuccess = false;
              // this.resetError = false;
            }, 3000);
          },
          error: (error) => {
            this.resetSuccess = true;
            this.disableResetBtn = false;
            this.resetForm.reset();

            // this.resetError = true;
            setTimeout(() => {
              this.resetSuccess = false;
              // this.resetError = false;
            }, 3000);
          }
        });
    }
  }

  public togglePassword() {
    this.passwordControlType = this.passwordControlType === 'password' ? 'text' : 'password';
  }

  public showResetForm() {
    this.showReset = true;
    this.passwordControlType = 'password';
    this.resetSuccess = false;

    if(this.signInForm.controls['email'].value) {
      this.resetForm.controls['email'].setValue(this.signInForm.controls['email'].value);
    }
    this.signInForm.reset();
  }

  public showSignInForm() {
    this.showReset = false;
    this.passwordControlType = 'password';
    this.resetSuccess = false;
    // if(this.resetForm.controls['email'].value) {
    //   this.signInForm.controls['email'].setValue(this.resetForm.controls['email'].value);
    // }
    this.resetForm.reset();
  }

}
